import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';

const tooltip = (
    <Tooltip id="actions-tooltip">Active is your current branch. Default is your landing branch upon login.</Tooltip>
);

const ActionHeader = () => (
    <>
        <span>Actions </span>
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={tooltip}>
            <FaInfoCircle />
        </OverlayTrigger>
    </>
);

export default ActionHeader;
